//Action Type Constants
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REDIRECT = "REDIRECT";

//Action Creators
export function login() {
  return {
    type: LOGIN,
    isAuthenticated: true
  };
}

export function logout() {
  return {
    type: LOGOUT,
    isAuthenticated: false
  };
}

export function loginSuccessRedirect(path) {
  return {
    type: REDIRECT,
    successRedirect: path
  };
}
